import React from 'react'

import Typography from 'components/UI/Typography/Typography'

import styles from './RatingCount.module.css'

type RatingCountProps = {
  ratingCount: number
}

const RatingCount: React.FC<RatingCountProps> = ({ ratingCount }) => (
  <div>
    <Typography.MetaBold
      className={styles.ratingCount}
    >{`(${ratingCount})`}</Typography.MetaBold>
  </div>
)

export default RatingCount
